export default __webpack_public_path__ + "static/media/2.b6b70722.png";